import { ArrowUpRight, MessageCircle } from "lucide-react";
import { useSite } from "@/lib/SiteContext";
import { useT } from "@/lib/i18n";
import { buildWhatsAppUrl } from "@/lib/constants";
import { trackWaClick } from "@/lib/track";
import Reveal from "./Reveal";

export const FinalCTA = () => {
  const { locale } = useSite();
  const { t } = useT(locale);

  return (
    <section
      id="contacto"
      className="relative py-28 md:py-44 overflow-hidden"
      style={{ backgroundColor: "var(--ix-night)", color: "var(--ix-cream)" }}
      data-testid="final-cta-section"
    >
      {/* Subtle gradient glow background */}
      <div className="absolute inset-0 pointer-events-none" aria-hidden>
        <div
          className="absolute inset-0"
          style={{
            background:
              "radial-gradient(ellipse at 70% 40%, rgba(252,180,36,0.16) 0%, transparent 55%), radial-gradient(ellipse at 25% 70%, rgba(255,31,143,0.10) 0%, transparent 60%)",
          }}
        />
        <div
          className="ix-float-1 absolute"
          style={{
            top: "15%", left: "8%",
            width: "150px", height: "200px",
            background: "linear-gradient(135deg, #FF1F8F 0%, #FCB424 100%)",
            clipPath: "polygon(22% 0%, 100% 0%, 78% 100%, 0% 100%)",
            opacity: 0.35,
          }}
        />
      </div>

      <div className="max-w-[1480px] mx-auto px-5 md:px-10 lg:px-14 relative">
        <div className="max-w-5xl">
          <Reveal>
            <div className="ix-mono text-[0.7rem] uppercase tracking-[0.18em] flex items-center gap-2">
              <span className="ix-grad-text font-semibold">◆</span>
              {t("finalCta.eyebrow")}
            </div>
          </Reveal>

          <Reveal delay={120}>
            <h2 className="ix-display ix-headline-xl mt-7 text-[var(--ix-cream)]">
              {(() => {
                const txt = t("finalCta.title");
                const lastWord = txt.split(" ").pop();
                const head = txt.slice(0, txt.length - lastWord.length);
                return (
                  <>
                    {head}
                    <span className="ix-grad-text" style={{ fontWeight: 700 }}>{lastWord}</span>
                  </>
                );
              })()}
            </h2>
          </Reveal>

          <Reveal delay={240}>
            <p className="mt-9 text-[1.05rem] md:text-[1.15rem] leading-relaxed text-[var(--ix-cream)]/75 max-w-2xl">
              {t("finalCta.sub")}
            </p>
          </Reveal>

          <Reveal delay={360}>
            <div className="mt-12 flex flex-col sm:flex-row gap-3">
              <a
                href={buildWhatsAppUrl()}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackWaClick("final_cta")}
                className="ix-btn ix-btn-grad"
                data-testid="final-whatsapp-cta"
              >
                <MessageCircle size={15} strokeWidth={1.8} />
                {t("finalCta.primary")}
                <ArrowUpRight size={14} strokeWidth={1.8} />
              </a>
              <a href="#lineas" className="ix-btn ix-btn-ghost" data-testid="final-explore-cta">
                {t("finalCta.secondary")}
              </a>
            </div>
          </Reveal>

          <Reveal delay={460}>
            <div className="mt-16 ix-rule-grad" />
            <div className="mt-5 ix-mono text-[0.7rem] uppercase tracking-[0.2em] text-[var(--ix-cream)]/55">
              {t("finalCta.footnote")}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
